module.exports = __webpack_public_path__ + "static/img/pro_bg.4ddce74b.png";